import axios from "axios";
import { getUserFromLS } from "../utils/getUserFromLS";
import { ISocialPrompt } from "../Types/account";
import { getTutorialSocialPrompt } from "./tutorialFixtureResponses";

export const getSpecificSocialPrompt = (
    socialPromptId: number,
    callback: (response: ISocialPrompt) => void, errorCallback
) => {
  const fixture = getTutorialSocialPrompt(socialPromptId);
  if (fixture) {
    if (callback != null) {
      callback(fixture as ISocialPrompt);
    }
    return Promise.resolve(fixture);
  }

  const user = getUserFromLS();

  const URL = `${import.meta.env.VITE_API_BASE_URL}/social_prompts/${socialPromptId}`;
  return axios(URL, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${user.access_token}`
    }
  })
    .then((response) => {
      if (callback != null) {
        callback(response.data as ISocialPrompt);
      }
    })
    .catch((error) => {
      if (errorCallback != null) {
        errorCallback(error);
      }
    });
}; 